<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="日期:">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属渠道:" v-if="isShow">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道包组:">
          <el-select
            v-model="searchValue.group_channel_ids"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelGroupSelectList"
              :key="item.id"
              :label="item.group_name"
              :value="item.group_channel_ids"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <commonMode
          ref="commonMode"
          @getList="(val) => {
            searchValue = {
              ...searchValue,
              ...val,
            }
            getReportList(true)
          }"
          :searchValue="{
            channel_id: searchValue.channel_id
          }" />
        <el-form-item>
          <el-button size="small" type="warning" @click="$refs.commonMode.dialogTableVisible = true">选择渠道策略组</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="$refs.commonMode.dialogCreateModeVisible = true">保存渠道策略组</el-button>
        </el-form-item>
        <br />
        <el-form-item label="是否分渠道:">
          <el-select
            v-model="searchValue.rechannel"
            filterable
            clearable
            placeholder="请选择"
            @change="rechannelChange"
          >
            <el-option
              v-for="item in listRechannel"
              :value="item.id"
              :label="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统计类型:">
          <el-select
            v-model="searchValue.append_type"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in appendTypeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchReportList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportReport()">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :summary-method="getSummaries"
      show-summary
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column fixed prop="daydate" label="统计日期" width="100" :resizable="false"> </el-table-column>
      <el-table-column prop="game.name" label="所属游戏" width="180" :resizable="false"> </el-table-column>
      <el-table-column prop="channels.name" label="所属渠道" width="180" :resizable="false"> </el-table-column>
      <el-table-column prop="login_num" label="登录人数" :resizable="false"> </el-table-column>
      <el-table-column prop="money" label="充值金额" :resizable="false"> </el-table-column>
      <el-table-column prop="pay_num" label="付费人数" :resizable="false"> </el-table-column>
      <el-table-column label="付费率" :resizable="false">
        <template slot-scope="scope">{{ scope.row.pay_rate }}%</template>
      </el-table-column>
      <el-table-column prop="arppu" label="付费AP" :resizable="false"> </el-table-column>
      <el-table-column prop="arpu" label="活跃AP" :resizable="false"> </el-table-column>
      <el-table-column prop="reg_num" label="新增注册" :resizable="false"> </el-table-column>
      <el-table-column prop="reg_no_repeat" label="去重注册(手机号)" :resizable="false">
      </el-table-column>
      <el-table-column prop="device_num" label="新增付费设备数" :resizable="false">
      </el-table-column>
      <el-table-column prop="device_reg" label="新增注册设备数" :resizable="false">
      </el-table-column>
      <el-table-column prop="device_activate" label="新增激活设备数" :resizable="false">
      </el-table-column>
      <el-table-column prop="new_first_money" label="新增首日付费金额" :resizable="false">
      </el-table-column>
      <el-table-column prop="first_money_num" label="新增首日付费人数" :resizable="false">
      </el-table-column>
      <el-table-column label="新增首日付费率" :resizable="false">
        <template slot-scope="scope">{{ scope.row.first_pay_rate }}%</template>
      </el-table-column>
      <el-table-column prop="new_first_arppu" label="新增首日arppu" :resizable="false">
      </el-table-column>
      <el-table-column prop="new_first_arpu" label="新增首日arpu" :resizable="false">
      </el-table-column>
      <el-table-column prop="total_pay_login" label="累计付费日活" :resizable="false">
      </el-table-column>
      <el-table-column label="累计付费率" :resizable="false">
        <template slot-scope="scope">{{ scope.row.pay_num_rate }}%</template>
      </el-table-column>
      <el-table-column prop="new_total_money" label="周期新增累计付费" :resizable="false">
      </el-table-column>
      <el-table-column prop="total_pay_num" label="新增付费账号" :resizable="false">
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
import moment from "moment";
import commonMode from '@/component/commonMode.vue'

export default {
  name: "report",
  components: {
    commonMode
  },
  data() {
    return {
      loadingData: false,
      value1: [],
      collect: [],
      searchValue: {
        game_id: "",
        channel_id: [],
        created_from: "",
        created_to: "",
        rechannel: "",
        group_channel_ids: "",
        append_type: "reg_num"
      },
      listRechannel: [
        {
          id: 0,
          name: "分渠道",
        },
        {
          id: 1,
          name: "不分渠道",
        },
      ],
      isShow: true,
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      gamesList: [],
      channelSelectList: [],
      channelSelectAllList: [],
      channelGroupSelectList: [],
      appendTypeList: [
        {
          value: 'reg_num',
          name: '新增用户'
        },
        {
          value: 'total_num',
          name: '总新增角色'
        },
        {
          value: 'first_num',
          name: '初次新增角色'
        },
        {
          value: 'repeat_num',
          name: '滚服角色数据'
        },
        {
          value: 'unique_devices',
          name: '设备去重'
        },
        {
          value: 'unique_ip',
          name: '用户IP去重'
        },
        {
          value: 'unique_double',
          name: '用户IP设备双去重'
        },
      ]
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.addDate();
    let date = moment().startOf("month"); //当月第一天
    let y = date.get("year");
    let m = date.get("month") + 1;
    let d = date.get("date");
    let dateStart = y + "-" + m + "-" + d + " " + "00:00:00";

    this.value1[0] = dateStart;
    this.value1[1] = this.systemTime;

    this.searchValue.created_from = this.value1[0];
    this.searchValue.created_to = this.value1[1].replace(
      "00:00:00",
      "23:59:59"
    );

    // 是否分渠道 默认选中项
    this.searchValue.rechannel = this.listRechannel[0].id;

    this.getGameSelectList();
    this.getChannelSelect();
    this.channelGroupSelect();
    this.getReportList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getReportList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getReportList(false);
    },

    addDate() {
      let date1 = moment().endOf("month"); //当月最后一天
      let yy = date1.get("year");
      let mm = date1.get("month") + 1;
      let dd = date1.get("date");
      this.systemTime = yy + "-" + mm + "-" + dd + " " + "23:59:59";
    },

    // 导出
    exportReport() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/statistics/total_data_report", params);
    },

    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },
    // 获取渠道选择列表数据
    getChannelSelect() {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        this.channelSelectAllList = res.data.data;
        this.channelSelectList = res.data.data;
      });
    },
    // 渠道包组 下拉选择列表
    channelGroupSelect() {
      fetch({
        url: "/admin/channel_package_group/select",
        method: "GET",
      }).then((res) => {
        this.channelGroupSelectList = res.data.data;
      });
    },

    // 通过选择是否分渠道 控制所属渠道是否显示或隐藏
    rechannelChange(selectValue) {
      if (selectValue == 1) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    // 根据所属游戏,显示对应的所属渠道
    selectChannel(vid) {
      let obj = {};
      obj = this.gamesList.find((item) => {
        return item.id == vid;
      });
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (obj) {
          if (item.game_id == obj.id) {
            this.channelSelectList.push(item);
          }
        } else {
          this.channelSelectList.push(item);
        }
      });
    },
    // 实现渠道包数据的搜索
    searchReportList() {
      this.searchValue.created_from = this.value1 && this.value1.length === 2 ? this.value1[0] : '';
      this.searchValue.created_to = this.value1 && this.value1.length === 2 ? this.value1[1] : '';
      this.currentPage = 1;
      this.getReportList(true);
    },
    // 展示用户角色列表数据
    getReportList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      let channel_id = this.searchValue.channel_id.toString();
      fetch({
        url: "/admin/statistics/total_data_report",
        method: "GET",
        params: {
          ...searchValue,
          channel_id: channel_id,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data[0].data;
            this.collect = res.data.data.collect;
            this.totalRecords = res.data.data[0].total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    // 数据统计
    getSummaries(param) {
      let arr = [];
      arr[0] = "合计";
      arr[1] = "";
      arr[2] = "";
      arr[3] = this.collect.login_num;
      arr[4] = this.collect.money_total;
      arr[5] = this.collect.disc_pay_num;
      arr[6] = this.collect.pay_rate + "%";
      arr[7] = this.collect.arppu;
      arr[8] = this.collect.arpu;
      arr[9] = this.collect.reg_num_total;
      arr[10] = this.collect.user_total;
      arr[11] = this.collect.device_num;
      arr[12] = this.collect.device_reg;
      arr[13] = this.collect.device_activate;
      arr[14] = this.collect.new_first_money_total;
      arr[15] = this.collect.disc_first_money_num;
      arr[16] = this.collect.first_pay_rate + "%";
      arr[17] = this.collect.new_first_arppu;
      arr[18] = this.collect.new_first_arpu;
      arr[19] = this.collect.total_pay_login;
      arr[20] = (this.collect.pay_num_rate || 0) + "%";
      arr[21] = this.collect.new_total_money;
      arr[22] = this.collect.total_pay_num;
      return arr;
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
</style>
